"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _handlers = require("../../../../../../helpers/handlers");
var _actions = require("../../../../store/actions");
var _constants = require("../../../../store/constants");
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var STATUSES_ITEMS = [_constants.BASKET_STATUSES_MAP.ALL, _constants.BASKET_STATUSES_MAP.ARCHIVE];
var StyledLink = _styledComponents.default.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", "\n"])), function (props) {
  return props.theme.primaryColor;
});
var StatusControl = function StatusControl(_ref) {
  var activeStatus = _ref.activeStatus,
    onChange = _ref.onChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKETS_SEARCH_FORM'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.title
  }, t('STATUS_CONTROL_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.menuWrapper
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _styles.default.menu
  }, R.map(function (status) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: _styles.default.menuItem,
      key: status
    }, /*#__PURE__*/_react.default.createElement(StyledLink, {
      className: (0, _classnames2.default)(_styles.default.menuLink, _defineProperty({}, _styles.default.active, activeStatus === status)),
      href: "#",
      onClick: (0, _handlers.handleWith)(_handlers.prevent, function () {
        onChange(status);
        dispatch((0, _actions.setActiveBasketsStatus)(status));
      })
    }, t("STATUS_CONTROL_ITEM_".concat(status, "_LABEL"))));
  }, STATUSES_ITEMS))));
};
StatusControl.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  activeStatus: _propTypes.default.oneOf(STATUSES_ITEMS)
};
var _default = exports.default = (0, _react.memo)(StatusControl);